import axios from "axios";
//const BASE_URL = "https://plusliveth.com/api";
//const BASE_URL = "http://127.0.0.1:8442/api";
const BASE_URL = "/api";

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});
